export const sparkleOptionsList = [
  {
    // Sparkle 1 
    fullScreen: { enable: false },
    particles: {
      number: { value: 15 },
      color: { value: ['#fff200', '#ffe600'] },
      opacity: { value: { min: 0.6, max: 1 } },
      size: { value: { min: 3, max: 5 } },
      move: {
        enable: true,
        speed: 1.5,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.8 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 2 
    fullScreen: { enable: false },
    particles: {
      number: { value: 25 },
      color: { value: ['#ffffff'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 1, max: 3 } },
      move: {
        enable: true,
        speed: 2,
        direction: 'random',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.6 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 3
    fullScreen: { enable: false },
    particles: {
      number: { value: 12 },
      color: { value: ['#ff69b4', '#ffb6c1'] },
      opacity: { value: { min: 0.6, max: 1 } },
      size: { value: { min: 3, max: 6 } },
      shape: { type: 'star' },
      move: {
        enable: true,
        speed: 1.8,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.9 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 4 
    fullScreen: { enable: false },
    particles: {
      number: { value: 18 },
      color: { value: ['#00ffff', '#66ffff'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 2, max: 5 } },
      move: { enable: true, speed: 2, direction: 'top', outModes: 'destroy' },
      life: { duration: { value: 0.8 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 5 
    fullScreen: { enable: false },
    particles: {
      number: { value: 15 },
      color: { value: ['#800080', '#9932cc'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 3, max: 5 } },
      move: {
        enable: true,
        speed: 1.5,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 1 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 6 
    fullScreen: { enable: false },
    particles: {
      number: { value: 18 },
      color: { value: ['#00ff00', '#66ff66'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 2, max: 5 } },
      move: {
        enable: true,
        speed: 1.8,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.8 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 7
    fullScreen: { enable: false },
    particles: {
      number: { value: 10 },
      color: { value: ['#fff200'] },
      opacity: { value: { min: 0.7, max: 1 } },
      size: { value: { min: 4, max: 6 } },
      shape: { type: 'star' },
      move: {
        enable: true,
        speed: 1.2,
        direction: 'random',
        outModes: 'destroy',
      },
      life: { duration: { value: 1 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 8
    fullScreen: { enable: false },
    particles: {
      number: { value: 20 },
      color: { value: ['#ffa500', '#ffb84d'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 2, max: 4 } },
      move: {
        enable: true,
        speed: 1.5,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.7 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 9 
    fullScreen: { enable: false },
    particles: {
      number: { value: 25 },
      color: { value: ['#99ccff', '#66ccff'] },
      opacity: { value: { min: 0.4, max: 0.8 } },
      size: { value: { min: 2, max: 4 } },
      move: { enable: true, speed: 2, direction: 'top', outModes: 'destroy' },
      life: { duration: { value: 0.7 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 10 
    fullScreen: { enable: false },
    particles: {
      number: { value: 20 },
      color: { value: ['#ffffff', '#f0f0ff'] },
      opacity: { value: { min: 0.6, max: 1 } },
      size: { value: { min: 3, max: 5 } },
      move: {
        enable: true,
        speed: 1.5,
        direction: 'random',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.8 }, count: 1 },
    },
    detectRetina: true,
  }, 
  // Sparkle 1 
  {
    fullScreen: { enable: false },
    particles: {
      number: { value: 20 },
      color: { value: ['#fff200', '#ffe600', '#ffffaa'] },
      opacity: { value: { min: 0.4, max: 0.8 } },
      size: { value: { min: 3, max: 6 } },
      move: {
        enable: true,
        speed: 1.5,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.8 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 2 
    fullScreen: { enable: false },
    particles: {
      number: { value: 30 },
      color: { value: ['#00f', '#0ff', '#fff'] },
      opacity: { value: { min: 0.5, max: 1 } },
      size: { value: { min: 2, max: 4 } },
      move: { enable: true, speed: 3, direction: 'top', outModes: 'destroy' },
      life: { duration: { value: 0.5 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 3 
    fullScreen: { enable: false },
    particles: {
      number: { value: 25 },
      color: {
        value: [
          '#ff0000',
          '#ff9900',
          '#ffff00',
          '#00ff00',
          '#0000ff',
          '#9900ff',
        ],
      },
      opacity: { value: { min: 0.3, max: 0.7 } },
      size: { value: { min: 4, max: 8 } },
      move: {
        enable: true,
        speed: 2,
        direction: 'random',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.6 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 4 
    fullScreen: { enable: false },
    particles: {
      number: { value: 15 },
      color: { value: ['#ff69b4', '#ff1493'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      shape: { type: 'circle' },
      size: { value: { min: 5, max: 10 } },
      move: { enable: true, speed: 1.2, direction: 'top', outModes: 'destroy' },
      life: { duration: { value: 1 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 5 
    fullScreen: { enable: false },
    particles: {
      number: { value: 25 },
      color: { value: ['#00ff00', '#66ff66', '#99ff99'] },
      opacity: { value: { min: 0.4, max: 0.7 } },
      size: { value: { min: 3, max: 6 } },
      move: {
        enable: true,
        speed: 1.8,
        direction: 'none',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.7 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 6 
    fullScreen: { enable: false },
    particles: {
      number: { value: 20 },
      color: { value: ['#ff0000', '#ff4500', '#ffa500'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 2, max: 5 } },
      move: {
        enable: true,
        speed: 2.5,
        direction: 'bottom',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.6 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 7
    fullScreen: { enable: false },
    particles: {
      number: { value: 35 },
      color: { value: ['#00ffff', '#66ffff', '#99ffff'] },
      opacity: { value: { min: 0.3, max: 0.7 } },
      size: { value: { min: 2, max: 5 } },
      move: {
        enable: true,
        speed: 3,
        direction: 'bottom',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.5 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 8 
    fullScreen: { enable: false },
    particles: {
      number: { value: 20 },
      color: { value: ['#800080', '#9932cc', '#ba55d3'] },
      opacity: { value: { min: 0.4, max: 0.8 } },
      size: { value: { min: 3, max: 7 } },
      move: {
        enable: true,
        speed: 2,
        direction: 'random',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.8 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 9 
    fullScreen: { enable: false },
    particles: {
      number: { value: 40 },
      color: { value: ['#ffffff', '#e6e6ff'] },
      opacity: { value: { min: 0.4, max: 0.9 } },
      size: { value: { min: 2, max: 5 } },
      move: { enable: true, speed: 1.5, direction: 'top', outModes: 'destroy' },
      life: { duration: { value: 1 }, count: 1 },
    },
    detectRetina: true,
  },
  {
    // Sparkle 10
    fullScreen: { enable: false },
    particles: {
      number: { value: 25 },
      color: { value: ['#ffa500', '#ffb84d', '#ffd580'] },
      opacity: { value: { min: 0.5, max: 0.9 } },
      size: { value: { min: 3, max: 6 } },
      move: {
        enable: true,
        speed: 2,
        direction: 'random',
        outModes: 'destroy',
      },
      life: { duration: { value: 0.7 }, count: 1 },
    },
    detectRetina: true,
  },
]
